import React, { useState, useEffect } from 'react';
import { Trans } from 'react-i18next';
import TagManager from 'react-gtm-module';
import RightArrow from '../AppContent/RightArrow';
import BuildingMap from '../HouseMap/BuildingMap';
import { BuildingWithConvertedAddresses, LatLng } from '../utils/types';
import './LandingPagePropertyMap.scss';

interface LandingPagePropertyMapProps {
  selectedBuilding: BuildingWithConvertedAddresses | null;
  selectBuilding: (building: BuildingWithConvertedAddresses) => void;
  userLocation: LatLng | null;
  handleShowLandingPagePropertyMap: () => void;
}

const LandingPagePropertyMap: React.FC<LandingPagePropertyMapProps> = ({
  selectedBuilding,
  selectBuilding,
  userLocation,
  handleShowLandingPagePropertyMap,
}) => {
  const [mapCenter, setMapCenter] = useState<LatLng>(() => {
    // Default to Helsinki center if no user location
    return userLocation || { lat: 60.168495304773955, lng: 24.92855807961784 };
  });

  const [triggeredFromSearch, setTriggeredFromSearch] = useState(false);
  const [countryOfFeedContent, setCountryOfFeedContent] = useState('Finland');
  const [lastMapBoundaryBoxCenter, setLastMapBoundaryBoxCenter] = useState<LatLng | null>(null);
  const [lastZoomLevel, setLastZoomLevel] = useState<number | null>(null);

  useEffect(() => {
    if (userLocation) {
      setMapCenter(userLocation);
    }
  }, [userLocation]);

  return (
    <div className="landing-page-property-map">
      <div className="landing-page-property-map__wrapper">
        <div className="landing-page-property-map__title">
          <button
            className="landing-page-property-map__title__button"
            onClick={() => {
              TagManager.dataLayer({
                dataLayer: {
                  event: 'property_map_title_landing_page_clicked',
                  category: 'User Interaction',
                  action: 'Click',
                  label: 'Property Map Title Landing Page Clicked',
                },
              });
              handleShowLandingPagePropertyMap();
            }}
          >
            <Trans i18nKey="propertyMap.title" />
            <RightArrow fill="#222" size={12} />
          </button>
        </div>
        <div className="landing-page-property-map__container">
          <div className="landing-page-property-map__map-wrapper">
            <BuildingMap
              mapCenter={mapCenter}
              selectedBuilding={selectedBuilding}
              triggeredFromSearch={triggeredFromSearch}
              feedIsOpen={false}
              mobileFeedIsOpen={false}
              countryOfFeedContent={countryOfFeedContent}
              lastMapBoundaryBoxCenter={lastMapBoundaryBoxCenter}
              lastZoomLevel={lastZoomLevel}
              initialMapZoom={12.5}
              isLandingPage={true}
              setShowFeed={() => { }}
              setTriggeredFromSearch={setTriggeredFromSearch}
              selectBuilding={selectBuilding}
              setCountryOfFeedContent={setCountryOfFeedContent}
              setLastMapBoundaryBoxCenter={setLastMapBoundaryBoxCenter}
              setLastZoomLevel={setLastZoomLevel}
              isSmallMap
            />
          </div>
          <div
            className="landing-page-property-map__explore-hint"
            onClick={() => {
              TagManager.dataLayer({
                dataLayer: {
                  event: 'property_map_explore_hint_landing_page_clicked',
                  category: 'User Interaction',
                  action: 'Click',
                  label: 'Property Map Explore Hint Landing Page Clicked',
                },
              });
              handleShowLandingPagePropertyMap();
            }}
          >
            <Trans i18nKey="propertyMap.exploreHint" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPagePropertyMap;
